export default __webpack_public_path__ + "static/hovercards-dark-6c8f869c55fe082a8405fc01a8096839.png";